import React from 'react';
import styles from './Form.module.css';
import LoginButton from '../Button/Login/LoginButton';

export default function CreateForm({ formData, setFormData, onSubmit, text="Submit", fields = [] }) {
  // Check if fields is an array before proceeding
  if (!Array.isArray(fields)) {
    console.error('Fields is not an array:', fields);
    return <div>Error: Form configuration invalid</div>;
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevData => ({ ...prevData, [name]: value }));
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (typeof onSubmit === 'function') {
      onSubmit(e);
    } else {
      console.error('onSubmit is not a function');
    }
  };

  return (
    <form onSubmit={handleFormSubmit} className={styles.form}>
      {fields.map((field, index) => { 
        // Skip hidden fields in rendering (but they'll still be in formData)
        if (field.hidden || field.type === 'hidden') {
          return null;
        } 
        
        // Generate unique key for each field
        const fieldKey = `${field.name}-${index}`;

        // Handle text, email, and password fields
        if (field.type === 'text' || field.type === 'email' || field.type === 'password'  || field.type === 'number') {
          return (
            <div key={fieldKey} className={styles.formGroup}>
              <label htmlFor={field.name}>{field.label || field.name}</label>
              <div className={styles.inputWrapper}>
                {field.icon && <i className={`fa ${field.icon}`} aria-hidden="true"></i>}
                <input
                  type={field.type}
                  name={field.name}
                  id={field.name}
                  value={formData[field.name] || ''}
                  placeholder={field.placeholder}
                  required={field.required}
                  className={styles.input}
                  onChange={handleInputChange}
                />
              </div>
            </div>
          );
        }
                // ✅ Handle select (dropdown)
                if (field.type === 'select') {
                  return (
                    <div key={fieldKey} className={styles.formGroup}>
                      <label htmlFor={field.name}>{field.label || field.name}</label>
                      <div className={styles.inputWrapper}>
                        {field.icon && <i className={`fa ${field.icon}`} aria-hidden="true"></i>}
                        <select
                          name={field.name}
                          id={field.name}
                          value={formData[field.name] || ''}
                          required={field.required}
                          className={styles.input}
                          onChange={handleInputChange}
                        >
                          <option value="" disabled>{field.placeholder || 'Select an option'}</option>
                          {field.options.map((option, idx) => (
                            <option key={`${field.name}-opt-${idx}`} value={option}>
                              {option}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  );
                }
                
        // Handle radio fields
        if (field.type === 'radio') {
          return (
            <div key={fieldKey} className={`${styles.formGroup} ${styles.radioGroup}`}>
              <label>{field.label}</label>
              <div className={styles.radioOptionsContainer}>
                {field.options.map((option) => (
                  <div key={`${field.name}-${option}`} className={styles.radioOption}>
                    <input
                      type="radio"
                      name={field.name}
                      value={option}
                      id={`${field.name}-${option}`}
                      checked={formData[field.name] === option}
                      required={field.required}
                      onChange={handleInputChange}
                    />
                    <label htmlFor={`${field.name}-${option}`}>{option}</label>
                  </div>
                ))}
              </div>
            </div>
          );
        }

        // Handle checkbox fields
        if (field.type === 'checkbox') {
          return (
            <div key={fieldKey} className={styles.formGroup}>
              <div className={styles.checkboxContainer}>
                <input
                  type="checkbox"
                  name={field.name}
                  id={field.name}
                  checked={formData[field.name] || false}
                  required={field.required}
                  onChange={(e) => {
                    setFormData(prevData => ({ ...prevData, [field.name]: e.target.checked }));
                  }}
                />
                <label htmlFor={field.name}>{field.label}</label>
              </div>
            </div>
          );
        }

        // Default return for unknown field types
        return null;
      })}

      <LoginButton text={text} type="submit" disabled={false} />
    </form>
  );
}